import { getTopLeft, getWidth } from "ol/extent";
import TileLayer from "ol/layer/Tile";
import { get as getProjection } from 'ol/proj';
import WMTS from "ol/source/WMTS";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import { ServerLayer } from "../../../lib/layers";
import { Some } from "../../../lib/misc/option";
import { EPSG } from "../../../lib/projection";
export class WMTSPictometryLayer extends ServerLayer {
    constructor(opts) {
        super(opts);
    }
    get layers() {
        return this.raw.map(l => [l]).unwrapOr([]);
    }
    validate(opts) {
        let result = true;
        result && (result = typeof opts.infoUrl === 'string');
        result && (result = Array.isArray(opts.exportUrl) && opts.exportUrl.every(u => typeof u === 'string'));
        result && (result = opts.isBaseLayer !== undefined && opts.visible !== undefined);
        result && (result = typeof opts.isBaseLayer === 'boolean' && typeof opts.visible === 'boolean');
        return result;
    }
    async parse_config(opts) {
        var _a, _b;
        this.is_base = opts.isBaseLayer;
        this.name = opts.name;
        const projection = getProjection("EPSG:3857");
        const projectionExtent = projection.getExtent();
        const size = getWidth(projectionExtent) / 256;
        const maxZoom = 22;
        const resolutions = [];
        const matrixIds = [];
        for (let z = 0; z <= maxZoom; z++) {
            resolutions[z] = size / Math.pow(2, z);
            matrixIds[z] = z.toString();
        }
        const layerId = opts.layerId;
        const baseUrl = `${opts.exportUrl[0]}/wmts`;
        const layer = new TileLayer({
            opacity: opts.opacity,
            visible: opts.visible,
            source: new WMTS({
                url: `${baseUrl}/${layerId}/{Style}/{TileMatrixSet}/{TileMatrix}/{TileCol}/{TileRow}.png`,
                layer: layerId,
                format: "image/png",
                matrixSet: "GoogleMapsCompatible",
                style: "default",
                tileGrid: new WMTSTileGrid({
                    origin: getTopLeft(projectionExtent),
                    resolutions: resolutions,
                    matrixIds: matrixIds
                }),
                wrapX: false,
                crossOrigin: 'anonymous',
                requestEncoding: 'REST',
            })
        });
        this.raw = new Some(layer);
        this.projection = EPSG(projection.getCode().split(':')[1]);
        (_a = layer.getSource()) === null || _a === void 0 ? void 0 : _a.on("tileloadstart", () => {
            this.display_loading_indicator(true);
        });
        (_b = layer.getSource()) === null || _b === void 0 ? void 0 : _b.on("tileloadend", () => {
            this.display_loading_indicator(false);
        });
    }
}
